import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "table"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonSeach = _resolveComponent("CommonSeach");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_AddAttrValue = _resolveComponent("AddAttrValue");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white",
    style: {
      "min-height": "calc( 100% - 80px )"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_CommonSeach, {
      diySerach: $setup.data.diySerach,
      "onUpdate:diySerach": _cache[0] || (_cache[0] = $event => $setup.data.diySerach = $event),
      onGetChangeValue: $setup.getChangeValue,
      onGetSeachData: $setup.getSeachData,
      onClearValue: $setup.clearValue
    }, null, 8, ["diySerach", "onGetChangeValue", "onGetSeachData", "onClearValue"]), _createVNode(_component_el_row, {
      class: "title_box_prop"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => $setup.handleEdit('', 'add'))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("新增属性值")])),
          _: 1,
          __: [4]
        })]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_table, {
      data: $setup.data.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        align: "center",
        prop: "attribute_value_id",
        label: "属性ID",
        width: "95"
      }), _createVNode(_component_el_table_column, {
        label: "属性名称",
        prop: "name",
        align: "center",
        width: "300"
      }), _createVNode(_component_el_table_column, {
        label: "属性值名称",
        prop: "value",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "属性值状态",
        align: "center",
        width: "150"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_switch, {
          modelValue: scope.row.status,
          "onUpdate:modelValue": $event => scope.row.status = $event,
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0,
          onChange: $event => $setup.handleSwitch(scope.row)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        fixed: "right",
        width: "150",
        label: "操作",
        prop: "",
        align: "center"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_button, {
          title: "编辑",
          type: "text",
          onClick: $event => $setup.handleEdit(scope.row, 'edit')
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("编辑")])),
          _: 2,
          __: [5]
        }, 1032, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"]), _createVNode(_component_el_pagination, {
      class: "m-t-20 m-b-20",
      "current-page": $setup.query_form.page,
      "page-sizes": [50, 100, 150],
      "page-size": $setup.query_form.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: $setup.data.count,
      onSizeChange: $setup.handleSizeChange,
      onCurrentChange: $setup.handleCurrentChange,
      small: ""
    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]), _createElementVNode("div", null, [_createVNode(_component_AddAttrValue, {
      attrIsShow: $setup.data.attrIsShow,
      "onUpdate:attrIsShow": _cache[2] || (_cache[2] = $event => $setup.data.attrIsShow = $event),
      attRow: $setup.data.attRow,
      "onUpdate:attRow": _cache[3] || (_cache[3] = $event => $setup.data.attRow = $event),
      onAttrSure: $setup.attrSure
    }, null, 8, ["attrIsShow", "attRow", "onAttrSure"])]), _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1))]),
    _: 1,
    __: [6]
  });
}